import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ProvidersProps } from '../providers.types';

const client = new QueryClient();

const ReactQueryProvider: React.FC<ProvidersProps> = ({ children }) => (
  <QueryClientProvider client={client}>
    {children}
    <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
  </QueryClientProvider>
);
export default ReactQueryProvider;
